import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

export default defineNuxtRouteMiddleware(() => {
  return navigateTo({ name: 'party-uuid-inventories' }, { redirectCode: 301 })
})
